import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_WEBHOOKS,
  CREATE_WEBHOOKS,
  UPDATE_WEBHOOKS,
  DELETE_WEBHOOKS,
  GET_WEBHOOKS_SUCCESS,
  GET_WEBHOOKS_FAILED,
  UPDATE_WEBHOOKS_SUCCESS,
  UPDATE_WEBHOOKS_FAILED,
  CREATE_WEBHOOKS_FAILED,
  DELETE_WEBHOOKS_SUCCESS,
  DELETE_WEBHOOKS_FAILED,
} from './constants';

import {
  GetWebhooksRequestBuilder,
  GetWebhooksCountRequestBuilder,
  CreateWebhookRequestBuilder,
  DeleteWebhookRequestBuilder,
  UpdateWebhookRequestBuilder,
} from 'client-sdk/src/webhooks/webhooks';
import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import {flattenObject} from '../../utils/helpers';
import handleNotfication from '../../utils/handleNotfication.tsx';
import {CREATE_WAREHOUSES_SUCCESS} from '../warehouses/constants';

const token = localStorage.getItem('token') || '';

export function* getWebhooks(actions: any): unknown {
  try {
    const makeRequest = new GetWebhooksRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetWebhooksCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    const count = yield client.execute(makeCountRequest);
    yield put({
      type: GET_WEBHOOKS_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_WEBHOOKS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* updateWebhook(actions: any): unknown {
  const {body, pagination, callback} = actions.payload;
  try {
    const makeUpdateRequest = new UpdateWebhookRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateRequest);
    yield put({
      type: UPDATE_WEBHOOKS_SUCCESS,
    });
    yield put({
      type: GET_WEBHOOKS,
      payload: {
        ...pagination,
      },
    });
    handleNotfication('وب هوک مورد نظر با موفقیت ویرایش شد ', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: UPDATE_WEBHOOKS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* createWebhook(actions: any): unknown {
  const {body, pagination, id, callback} = actions.payload;
  try {
    const makeRequest = new CreateWebhookRequestBuilder().data(body).build();
    const client = new Client(token);
    yield client.execute(makeRequest);
    yield put({
      type: CREATE_WAREHOUSES_SUCCESS,
    });
    yield put({
      type: GET_WEBHOOKS,
      payload: {...pagination},
    });
    handleNotfication('وب هوک با موفقیت اضافه شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: CREATE_WEBHOOKS_FAILED,
      error: error.message,
    });
    handleNotfication('اضافه کردن وب هوک با خطا مواجه شد', 'error');
    handleError(error);
  }
}

export function* deleteWebhook(actions: any): unknown {
  try {
    const makeRequest = new DeleteWebhookRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: DELETE_WEBHOOKS_SUCCESS,
    });
    handleNotfication('وب هوک با موفقیت حذف شد', 'success');
    yield put({
      type: GET_WEBHOOKS,
    });
  } catch (error) {
    yield put({
      type: DELETE_WEBHOOKS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export default function* webHooksSaga() {
  yield takeLatest(GET_WEBHOOKS, getWebhooks);
  yield takeLatest(CREATE_WEBHOOKS, createWebhook);
  yield takeLatest(UPDATE_WEBHOOKS, updateWebhook);
  yield takeLatest(DELETE_WEBHOOKS, deleteWebhook);
}
